/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { CIColors, ClusterStates } from 'shared';

export const clusterStatusColors = {
  [ClusterStates.Running]: CIColors.Success,
  [ClusterStates.Creating]: CIColors.Warning,
  [ClusterStates.Updating]: CIColors.Tertiary,
  [ClusterStates.Unavailable]: CIColors.GraphicElements,
  [ClusterStates.Error]: CIColors.Error,
  [ClusterStates.Importing]: CIColors.Secondary,
  [ClusterStates.Starting]: CIColors.Tertiary,
  [ClusterStates.Stopping]: CIColors.Warning,
  [ClusterStates.Stopped]: CIColors.GraphicElements,

  __fallback: CIColors.GraphicElements,
};
